import React, { Component } from 'react';
import './conclusao.scss';


class Conclusao extends Component {


  componentDidMount(){
    if(!this.props.conclusao || !this.props.conclusao.title){
      this.props.history.push('/vamosComecar');
      return;
    }
 
    setTimeout(()=>{
      window.localStorage.clear();
      window.location.href = "https://btcorretora.com.br/"
    },15000)
   

  }

  render() {

    return (
    <div className="conclusao">
      <div className="col">
          <i className={ `icon fa ${this.props.conclusao.icon}`}></i>
        </div>
      <div className="container">
        <div className="col">
          <h1 className="title">{this.props.conclusao.title}</h1>
          <span className="message">{this.props.conclusao.discription} <b>{this.props.conclusao.email}</b></span>
        </div>
      </div>
    </div>)
  }
}

export default Conclusao;